import { render, staticRenderFns } from "./CambiarDatosPasoUno.vue?vue&type=template&id=84b73416"
import script from "./CambiarDatosPasoUno.vue?vue&type=script&lang=js"
export * from "./CambiarDatosPasoUno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports